import React from 'react';
import PropTypes from 'prop-types';
import Translate from 'components/Translate';
import NavigationUtil from 'utils/NavigationUtil';
import LevelMarker from '../../level/LevelMarker';
import { handleTooltips } from 'utils/deprecated/ToolTipUtil';

// utils -- userSocialProfileImage
import profileImageHelperV2 from 'utils/userSocialProfileImage/profileImageHelperV2';
import 'utils/userSocialProfileImage/profileImageTypeDefsV2';

import { fetchConnectionsForBadge } from '../../../actions/badgesActions';

import styles from './ConnectionsWithBadge.module.css';

class ConnectionsWithBadge extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            connections: props.badge.connections
        };

        this.fetching = false;
    }

    render() {
        const { badge } = this.props;

        if (badge.connectionNumber === 0) {
            return (
                <div className="connections-with-badge">
                    <h4 className="h5">
                        <Translate ns="badges" content="connections_badge" />
                    </h4>
                    <div className="badge-connections-msg">
                        <Translate ns="badges" content="no_connections_earned_badge" />
                    </div>
                </div>
            );
        }

        const remainingConnections = badge.connectionNumber - this.state.connections.length;

        return (
            <div className="connections-with-badge">
                <h4 className="h5">
                    <Translate ns="badges" content="connections_badge" />
                </h4>

                {this.renderConnections()}

                {remainingConnections > 0 ? (
                    <a className="additional-connections" href="" onClick={(e) => this.loadMoreConnections(e)}>
                        +{remainingConnections}
                    </a>
                ) : null}
            </div>
        );
    }

    getProfileImageDtoSrc = (connection) => {
        const { profileImageDtoMapState } = this.props;

        /**
         * @type {SimplePublicSocialProfileV2DTO}
         */
        const profileImageDtoOfUser = profileImageDtoMapState?.[connection?.userProfileId];

        return profileImageHelperV2.getDtoMediumIconImage(profileImageDtoOfUser, connection?.profileImageUrlMedium);
    };

    renderConnections() {
        return this.state.connections.map((connection, index) => {
            const name = connection.fullName || connection.displayName;
            const imgSrc = this.getProfileImageDtoSrc(connection);
            const noclip = profileImageHelperV2.isNoclipProfile(imgSrc);

            return (
                <a
                    href={NavigationUtil.url('/profile/' + connection.displayName)}
                    title={name}
                    className={`has-tooltip ${styles.avatarWrapper}`}
                    onClick={(e) => this.onConnectionClicked(e)}
                    key={index}
                >
                    <img
                        src={imgSrc}
                        className="avatar avatar-small"
                        alt={name}
                        data-noclip={noclip}
                        onError={(evt) => {
                            evt.currentTarget.src = profileImageHelperV2.getDefaultProfileImage();
                            delete evt.currentTarget.dataset.noclip;
                        }}
                    />
                    <LevelMarker level={connection.userLevel} small={true} />
                </a>
            );
        });
    }

    onConnectionClicked(e) {
        NavigationUtil.anchorTagHandler(e);
    }

    loadMoreConnections(e) {
        e.preventDefault();
        if (this.fetching) {
            return;
        }
        this.fetching = true;

        const { badge, fetchMultipleUserSocialProfileImage } = this.props;

        let fetchSize = 20;

        const remainingConnections = badge.connectionNumber - this.state.connections.length;

        if (remainingConnections - fetchSize < 2) {
            fetchSize += 1;
        }

        fetchConnectionsForBadge(badge.badgeId, this.state.connections.length + 1, fetchSize)
            .then((data) => {
                this.fetching = false;
                this.setState({
                    connections: [...this.state.connections, ...data]
                });
                if (Array.isArray(data) && data?.length > 0) {
                    fetchMultipleUserSocialProfileImage(data.map((item) => item.userProfileId));
                }
            })
            .catch(() => {
                this.fetching = false;
            });
    }

    componentDidUpdate() {
        handleTooltips();
    }

    componentDidMount() {
        handleTooltips();
    }
}

ConnectionsWithBadge.propTypes = {
    badge: PropTypes.object.isRequired
};

export default ConnectionsWithBadge;
